import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import swal from 'sweetalert2'
import Preloader from '../preloader/Preloader'
import $ from 'jquery'

//components
import { DataTableItem, UserRoute, BreadCrumb, Card } from 'src/components'

//services
import { getDeliveryZone, deleteDeliveryZone } from 'src/services'

const OrderTypes = () => {
  const [loading, setLoading] = useState(true)
  const [deliveryZoneList, setDeliveryZoneList] = useState([])

  useEffect(() => {
    getDeliveryZone()
      .then((res) => {
        if (res.data.status === 200) {
          setDeliveryZoneList(res.data.delivery_zones)
        }
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
      .catch(() => {
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
  }, [])

  const deleteRecord = (e, id) => {
    e.preventDefault()

    const thisClicked = e.currentTarget

    swal
      .fire({
        title: 'Are you sure you want to proceed?',
        text: 'This will completely delete the delivery zone permanently',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'Cancel!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteDeliveryZone(id)
            .then((res) => {
              if (res.data.status === 200) {
                swal.fire('Deleted!', res.data.message, 'success')
                thisClicked.closest('tr').remove()
              } else if (res.data.status === 404) {
                swal.fire('Error', res.data.message, 'error')
              }
            })
            .catch(() => {
              setTimeout(() => {
                $('#dataTable').DataTable({
                  scrollX: false,
                  pageLength: 100,
                })
              }, 10)
              setLoading(false)
            })
        } else if (result.isDenied) {
          swal.fire('Changes are not saved', '', 'info')
        }
      })
  }

  const renderRowActions = (item) => {
    return (
      <>
        <Link to={`/delivery_zones/update/${item.id}`} className="btn btn-info me-2">
          Edit
        </Link>
        <button onClick={(e) => deleteRecord(e, item.id)} className="btn btn-danger">
          Delete
        </button>
      </>
    )
  }

  const columns = [
    { label: 'Name', key: 'name' },
    // ... other columns
  ]

  const title = 'Delivery Zones'

  const breadcrumb = [
    {
      title: title,
      name: 'Add Delivery Zones',
      subtitle: '',
      subtitleroute: '',
    },
  ]

  const buttonValues = [
    {
      title: 'Add Delivery Zones',
      variants: 'btn btn-primary my-3 mr-2',
      routes: '/delivery_zones/create',
    },
  ]

  const cardValues = [
    {
      title: title,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <UserRoute data={buttonValues} />

      <Card data={cardValues}>
        {
          <DataTableItem
            data={deliveryZoneList}
            columns={columns}
            renderRowActions={renderRowActions}
          />
        }
      </Card>
    </div>
  )
}

export default OrderTypes
